<div class="modal-header">
  <h4 class="modal-title pull-left" [ngSwitch]="stage">
    <span *ngSwitchCase="StatStageType.COMPLETED"> Completed</span>
    <span *ngSwitchCase="StatStageType.FIRST_DRAFT">First Draft</span>
    <span *ngSwitchCase="StatStageType.DUE_TODAY"> Due Today</span>
    <span *ngSwitchCase="StatStageType.SUPPLEMENTAL_RECEIVED"> Supplemental Received</span>
    <span *ngSwitchCase="StatStageType.PAST_DUE"> Past Due</span>
    <span *ngSwitchCase="StatStageType.DUE_TOMORROW"> Due Tomorrow</span>
    <span *ngSwitchCase="StatStageType.ANALYST_OPEN_FILES">Analysts' Open Files</span>
    <span *ngSwitchCase="StatStageType.COMPLETED_REVENUE">Completed Orders & Revenue</span>
  </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span>
  </div>
</div>

<div class="modal-body">
  <loader [loading]="loading"></loader>

  <ng-container
    *ngIf="((reports && reports.length > 0) || (dueTodayReports && dueTodayReports.length > 0)) &&!loading; else noData">
    <!--FIRST_DRAFT-->
    <ng-container *ngIf="stage == StatStageType.FIRST_DRAFT">
      <div class="header-field">
        <div class="col">
          <span>Date</span>
        </div>

        <div class="col">
          <span>Day of Week</span>
        </div>

        <div class="col">
          <span>Reports</span>
        </div>
      </div>

      <div class="nested-result" *ngFor="let data of reports">
        <div class="result-field" (click)="data.COLLAPSE = !data.COLLAPSE" [attr.aria-expanded]="!data.COLLAPSE"
          aria-controls="collapseEvent">
          <div class="col">
            <span class="overflow-twoLn">{{data.DATE | date: 'MMM dd, yyyy hh:mm a'}}</span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{data.DATE | date: 'EEEE'}}</span>
          </div>

          <div class="col" style="display: flex; justify-content: space-between;">
            <span class="overflow-twoLn">{{data.REPORTS?.length}}</span>

            <fa *ngIf="data.REPORTS?.length > 0" style="color: #1e3762"
              [name]="data.COLLAPSE ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></fa>
          </div>
        </div>

        <div class="reports" [collapse]="!data.COLLAPSE" *ngIf="data.REPORTS?.length > 0">
          <div class="header-field">
            <div class="col">
              <span>Company Name</span>
            </div>

            <div class="col">
              <span>Stage</span>
            </div>

            <div class="col">
              <span>Assignee</span>
            </div>
          </div>

          <div class="result-field" *ngFor="let report of data.REPORTS">
            <div class="col">
              <span class="overflow-twoLn"><b>{{report.COMPANY_NAME}}</b></span>
            </div>

            <div class="col">
              <span class="overflow-twoLn">{{report.STAGE}}</span>
            </div>

            <div class="col">
              <span class="overflow-twoLn">{{report.ASSIGNEE}}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!--SUPPLEMENTAL-->
    <ng-container *ngIf="stage == StatStageType.SUPPLEMENTAL_RECEIVED">
      <div class="header-field">
        <div class="col">
          <span>Date</span>
        </div>

        <div class="col">
          <span>Day of Week</span>
        </div>

        <div class="col">
          <span>Reports</span>
        </div>
      </div>

      <div class="nested-result" *ngFor="let data of reports">
        <div class="result-field" (click)="data.COLLAPSE = !data.COLLAPSE" [attr.aria-expanded]="!data.COLLAPSE"
          aria-controls="collapseEvent">
          <div class="col">
            <span class="overflow-twoLn">{{data.DATE | date: 'MMM dd, yyyy, hh:mm a'}}</span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{data.DATE | date: 'EEEE'}}</span>
          </div>

          <div class="col" style="display: flex; justify-content: space-between;">
            <span class="overflow-twoLn">{{data.REPORTS?.length}}</span>

            <fa *ngIf="data.REPORTS?.length > 0" style="color: #1e3762"
              [name]="data.COLLAPSE ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></fa>
          </div>
        </div>

        <div class="reports" [collapse]="!data.COLLAPSE" *ngIf="data.REPORTS?.length > 0">
          <div class="header-field">
            <div class="col">
              <span>Company Name</span>
            </div>

            <div class="col">
              <span>Stage</span>
            </div>

            <div class="col">
              <span>Assignee</span>
            </div>
          </div>

          <div class="result-field" *ngFor="let report of data.REPORTS">
            <div class="col">
              <span class="overflow-twoLn"><b>{{report.COMPANY_NAME}}</b></span>
            </div>

            <div class="col">
              <span class="overflow-twoLn">{{report.STAGE}}</span>
            </div>

            <div class="col">
              <span class="overflow-twoLn">{{report.ASSIGNEE}}</span>
            </div>

          </div>
        </div>
      </div>
    </ng-container>

    <!--COMPLETED-->
    <ng-container *ngIf="stage ==  StatStageType.COMPLETED">
      <div class="header-field">
        <div class="col">
          <span>Date</span>
        </div>

        <div class="col">
          <span>Reports</span>
        </div>

        <div class="col">
          <span>Client Delay</span>
        </div>

        <div class="col">
          <span>Reliant Delay</span>
        </div>
      </div>

      <div class="nested-result" *ngFor="let data of reports">
        <div class="result-field" (click)="data.COLLAPSE = !data.COLLAPSE" [attr.aria-expanded]="!data.COLLAPSE"
          aria-controls="collapseEvent">
          <div class="col">
            <span class="overflow-twoLn">{{data.DATE | date: 'MMM dd, yyyy EEEE'}}</span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{data.TOTAL_REPORT}}</span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{data.TOTAL_CLIENT}}</span>
          </div>


          <div class="col" style="display: flex; justify-content: space-between;">
            <span class="overflow-twoLn">{{data.TOTAL_RELIANT}}</span>
            <fa *ngIf="data.REPORTS?.length > 0" style="color: #1e3762"
              [name]="data.COLLAPSE ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></fa>
          </div>
        </div>

        <div class="reports" [collapse]="!data.COLLAPSE" *ngIf="data.REPORTS?.length > 0">
          <div class="header-field">
            <div class="col">
              <span>Company Name</span>
            </div>

            <div class="col">
              <span>Stage</span>
            </div>

            <div class="col">
              <span>Financial Analyst</span>
            </div>

            <div class="col">
              <span>Day Submitted</span>
            </div>

            <div class="col">
              <span>Type of Delay</span>
            </div>
          </div>

          <div class="result-field" *ngFor="let report of data.REPORTS">
            <div class="col">
              <span class="overflow-twoLn"><b>{{report.COMPANY_NAME}}</b></span>
            </div>

            <div class="col">
              <span class="overflow-twoLn">{{report.STAGE}}</span>
            </div>

            <div class="col">
              <span class="overflow-twoLn">{{report.FA}}</span>
            </div>

            <div class="col">
              <span class="overflow-twoLn">{{report.DAY_SUBMITTED}}</span>
            </div>

            <div class="col">
              <span class="overflow-twoLn">{{report.DELAY}}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>


    <!--DUE TODAY-->
    <ng-container *ngIf="stage ==  StatStageType.DUE_TODAY">
      <div *ngIf="reports.length>0">
        <div class="header-field">
          <div class="col">
            <span>Company Name</span>
          </div>

          <div class="col">
            <span>Stage</span>
          </div>

          <div class="col">
            <span>Assignee</span>
          </div>

          <div class="col">
            <span>Days In Engaged</span>
          </div>

          <div class="col">
            <span>Delay</span>
          </div>
        </div>

        <div class="result-field" *ngFor="let report of reports">
          <div class="col">
            <span class="overflow-twoLn"><b>{{report.COMPANY_NAME}}</b></span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{report.STAGE}}</span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{report.ASSIGNEE}}</span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{report.DAY_ENGAGED}}</span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{report.DELAY}}</span>
          </div>

        </div>
      </div>


      <div class="col-12 px-0">
        <h5 [ngClass]="{'mt-5': reports.length>0}" class="mb-2">Delayed -Due Today</h5>
      </div>
      <div class="header-field">


        <div class="col">
          <span>Company Name</span>
        </div>

        <div class="col">
          <span>Stage</span>
        </div>

        <div class="col">
          <span>Assignee</span>
        </div>

        <div class="col">
          <span>Days In Engaged</span>
        </div>

        <div class="col">
          <span>Delay</span>
        </div>


      </div>

      <div class="result-field" *ngFor="let report of dueTodayReports">
        <div class="col">
          <span class="overflow-twoLn"><b>{{report.COMPANY_NAME}}</b></span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.STAGE}}</span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.ASSIGNEE}}</span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.DAY_ENGAGED}}</span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.DELAY}}</span>
        </div>

      </div>

    </ng-container>

    <!--PAST DUE-->
    <ng-container *ngIf="stage ==  StatStageType.PAST_DUE">
      <div class="header-field">
        <div class="col">
          <span>Company Name</span>
        </div>

        <div class="col">
          <span>Stage</span>
        </div>

        <div class="col">
          <span>Assignee</span>
        </div>

        <div class="col">
          <span>Days In Engaged</span>
        </div>
      </div>

      <div class="result-field" *ngFor="let report of reports">
        <div class="col">
          <span class="overflow-twoLn"><b>{{report.COMPANY_NAME}}</b></span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.STAGE}}</span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.ASSIGNEE}}</span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.DAY_ENGAGED}}</span>
        </div>

      </div>
    </ng-container>

    <!-- Analyst Open File -->
    <ng-container *ngIf="stage ==  StatStageType.ANALYST_OPEN_FILES">
      <div class="header-field">
        <div class="col-md-3">
          <span>Analyst</span>
        </div>

        <div class="col-md-3">
          <span>Open Files</span>
        </div>

      </div>

      <div class="nested-result" *ngFor="let data of reports">
        <div class="result-field" (click)="data.COLLAPSE = !data.COLLAPSE" [attr.aria-expanded]="!data.COLLAPSE"
          aria-controls="collapseEvent">
          <div class="col-md-3">
            <span class="overflow-twoLn"><b>{{data.ANALYST}}</b></span>
          </div>

          <div class="col-md-3" style="display: flex; justify-content: space-between;">
            <span class="overflow-twoLn">{{data.OPEN_FILES}}</span>
            <fa *ngIf="data.DATA?.length > 0" style="color: #1e3762"
              [name]="data.COLLAPSE ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></fa>
          </div>
        </div>
        <div class="reports" [collapse]="!data.COLLAPSE" *ngIf="data.DATA?.length > 0">
          <div class="header-field">
            <div class="col-lg-2">
              <span>Company Name</span>
            </div>

            <div class="col-lg-2">
              <span>Stage</span>
            </div>

            <div class="col-lg-2">
              <span>Due Date</span>
            </div>

            <div class="col-lg-2">
              <span>Days In Engaged</span>
            </div>
            <div class="col-lg-2">
              <span>Delay Type</span>
            </div>
            <div class="col-lg-2">
              <span>Tags</span>
            </div>
          </div>

          <div class="result-field" *ngFor="let report of data.DATA">
            <div class="col-lg-2">
              <span class="overflow-twoLn"><b>{{report.COMPANY_NAME}}</b></span>
            </div>
            <div class="col-lg-2">
              <span class="overflow-twoLn"><b>{{report.STAGE}}</b></span>
            </div>
            <div class="col-lg-2">
              <span class="overflow-twoLn"><b>{{report.DATE_DUE}}</b></span>
            </div>
            <div class="col-lg-2">
              <span class="overflow-twoLn"><b>{{report.DAY_ENGAGED}}</b></span>
            </div>
            <div class="col-lg-2">
              <span class="overflow-twoLn"><b>{{report.DELAY}}</b></span>
            </div>
            <div class="col-lg-2">
              <span class="overflow-twoLn"><b>{{report.TAGS}}</b></span>
            </div>
          </div>
        </div>
      </div>


    </ng-container>

    <!-- Delayed -Due Today -->
    <ng-container *ngIf="stage ==  StatStageType.DUE_TOMORROW">
      <div class="header-field">
        <div class="col">
          <span>Company Name</span>
        </div>

        <div class="col">
          <span>Stage</span>
        </div>

        <div class="col">
          <span>Assignee</span>
        </div>

        <div class="col">
          <span>Days In Engaged</span>
        </div>

        <div class="col">
          <span>Delay</span>
        </div>
      </div>

      <div class="result-field" *ngFor="let report of reports">
        <div class="col">
          <span class="overflow-twoLn"><b>{{report.COMPANY_NAME}}</b></span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.STAGE}}</span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.ASSIGNEE}}</span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.DAY_ENGAGED}}</span>
        </div>

        <div class="col">
          <span class="overflow-twoLn">{{report.DELAY}}</span>
        </div>

      </div>
    </ng-container>

    <!--COMPLETED REVENUE-->
    <ng-container *ngIf="stage ==  StatStageType.COMPLETED_REVENUE">
      <div class="header-field">
        <div class="col">
          <span>Company Name</span>
        </div>

        <div class="col">
          <span>Revenue</span>
        </div>
      </div>

      <div class="result-field" *ngFor="let data of reports">
         <div class="col">
            <span class="overflow-twoLn"><b>{{data.COMPANY_NAME}}</b></span>
          </div>

          <div class="col">
            <span class="overflow-twoLn">{{data.FEE}}</span>
          </div>
      </div>
    </ng-container>



  </ng-container>

  <ng-template #noData>
    <div style="text-align: center;padding: 30px;" *ngIf="!loading">
      <h4 style="margin-bottom: 10px;font-size: 34px;color: #a18cbc;"><i class="fa fa-table"></i></h4>
      <h4 style="margin-bottom: 10px;">No Report </h4>
    </div>
  </ng-template>

  <div class="row total-wrapper"
    *ngIf="reports && reports.length > 0 && stage ==  StatStageType.COMPLETED  && !loading">
    <div class="col"></div>

    <div class="col">
      <small>Total</small>
      <h4>{{getTotalReport()}}</h4>
    </div>

    <div class="col">
      <small>Total</small>
      <h4>{{getTotalClient()}}</h4>
    </div>

    <div class="col">
      <small>Total</small>
      <h4>{{getTotalReliant()}}</h4>
    </div>

  </div>

</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv" (click)="onSubmit()">Ok</button>
</div>